var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterSolid = function SvgFilterSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.25H4c-.96 0-1.75.79-1.75 1.75v1.59c0 .46.19.91.51 1.24l5.41 5.41s.07.11.07.18v7.5c0 .68.38 1.28.99 1.58a1.715 1.715 0 0 0 1.85-.21l3-2.4c.42-.33.66-.83.66-1.37v-5.11c0-.07.03-.13.07-.18l5.41-5.41c.33-.33.51-.78.51-1.24V3.99c0-.96-.79-1.75-1.75-1.75l.02.01Z"
  })));
};
export default SvgFilterSolid;